<template>
  <div class="align-items-center forgot-pass login">
    <div>
      <b-navbar type="dark" class="nav-up" toggleable="md" style="height: 35px;"></b-navbar>
      <b-navbar toggleable="md" class="nav-down" style="height: 40px;">
        <img src="/images/logo.svg" alt="FGA" class="center" />
      </b-navbar>
    </div>
    <div>
      <b-img src="/images/FONDOS.jpg" fluid class="img-titulo"></b-img>
      <h4 class="texto-titulo">Renueve su contraseña</h4>
    </div>
    <b-row>
      <b-col cols="12" md="8">
        <div class="panel1">
          <b-form @submit="onSubmit" @reset="onReset">
            <div>
              <h3 class="color-secundary">Renueve su contraseña</h3>
              <p class="mb-4 text-justify">Ingrese la nueva contraseña y realice la confirmación</p>
            </div>
            <b-form-group label="Código" label-for="codigo" :label-cols="4">
              <b-form-input id="codigo" type="text" v-model="usuario"></b-form-input>
            </b-form-group>
            <b-form-group label="Contraseña" label-for="password" :label-cols="4">
              <b-form-input
                id="password"
                type="password"
                v-model="password"
                autocomplete="password"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Confirmar" label-for="confirmar" :label-cols="4">
              <b-form-input
                id="confirmar"
                type="password"
                v-model="confirmar"
                autocomplete="confirmar"
              ></b-form-input>
            </b-form-group>
            <b-form-group label="Porcentaje de seguridad" label-for="progress" :label-cols="4">
              <b-progress :max="max" id="progress" class="mt-2 h-90">
                <b-progress-bar
                  :value="value"
                  :label-html="`${value}%`"
                  variant="dark"
                  v-if="value>0 && value <=30"
                ></b-progress-bar>
                <b-progress-bar
                  :value="value"
                  :label-html="`${value}%`"
                  variant="danger"
                  v-if="value>30 && value <=60"
                ></b-progress-bar>
                <b-progress-bar
                  :value="value"
                  :label-html="`${value}%`"
                  variant="warning"
                  v-if="value>60 && value <=90"
                ></b-progress-bar>
                <b-progress-bar
                  :value="value"
                  :label-html="`${value}%`"
                  variant="success"
                  v-if="value>90 && value <=100"
                ></b-progress-bar>
              </b-progress>
            </b-form-group>

            <div class="text-right">
              <b-button variant="outline-primary" style=" margin:2%" type="reset">Borrar</b-button>
              <b-button variant="outline-primary" style=" margin:2%" type="submit">Enviar</b-button>
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: "RenuevePassword",
  data() {
    return {
      value: 30,
      max: 100,
      codigo: "",
      password: "",
      confirmar: ""
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      var datos = [];
      datos.push({
        Usuario: this.usuario,
        Password: this.password,
        Confirmar: this.confirmar
      });
    },
    onReset(evt) {
      (this.usuario = ""), (this.password = ""), (this.confirmar = "");
    }
  }
};
</script>